import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { GiftActionsProps } from './GiftActions.types'

const GiftActions: React.FC<GiftActionsProps> = () => {
  // TODO: implement once modal component exists
  const onMarkAsPurchased = () => undefined

  return (
    <>
      <Button size="md" variant="tertiary" onClick={onMarkAsPurchased}>
        Unmark as purchased
      </Button>
    </>
  )
}

export default GiftActions
